import styled, { css } from 'styled-components'
import { TBodyTR } from 'src/components/TableComponents/style'

export const Wrapper = styled.div`
  flex: 2;
  width: 100%;
  padding: 0 20px;
  pointer-events: all;
`

export const TableBodyRow = styled(TBodyTR)`
  cursor: pointer;
  ${({ clicked = false }) => clicked
    && css`
      background-color: #ff1744 !important;
      color: #ffffff;
    `};
`
